module.exports = __webpack_public_path__ + "2c81d1fe955f29b2c1d6ced1986bdcdf.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/arrowl.png
// module id = 549
// module chunks = 21 54 55 56 77 79 80 88